import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-muted border-t border-border py-8 mt-16">
      <div className="container mx-auto px-4 text-center">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8 mb-8 text-left">
          <div>
            <h3 className="font-semibold text-foreground mb-3">Formatos Soportados</h3>
            <ul className="text-sm text-muted-foreground space-y-1">
              <li>Comprimir JPEG/JPG</li>
              <li>Optimizar PNG</li>
              <li>Convertir WebP</li>
              <li>Reducir GIF</li>
            </ul>
          </div>
          <div>
            <h3 className="font-semibold text-foreground mb-3">Casos de Uso</h3>
            <ul className="text-sm text-muted-foreground space-y-1">
              <li>Optimización para web</li>
              <li>Redes sociales</li>
              <li>Email marketing</li>
              <li>Almacenamiento eficiente</li>
            </ul>
          </div>
          <div>
            <h3 className="font-semibold text-foreground mb-3">Ventajas SEO</h3>
            <ul className="text-sm text-muted-foreground space-y-1">
              <li>Velocidad de carga mejorada</li>
              <li>Mejor Core Web Vitals</li>
              <li>Reducción de ancho de banda</li>
              <li>Experiencia de usuario superior</li>
            </ul>
          </div>
          <div>
            <h3 className="font-semibold text-foreground mb-3">Recursos</h3>
            <ul className="text-sm text-muted-foreground space-y-1">
              <li>
                <Link to="/faq" className="hover:text-primary transition-colors duration-200">
                  Preguntas Frecuentes
                </Link>
              </li>
              <li>
                <Link to="/quitar-fondo" className="hover:text-primary transition-colors duration-200">
                  Quitar Fondo de Imagen
                </Link>
              </li>
              <li>
                <Link to="/blog" className="hover:text-primary transition-colors duration-200">
                  Blog y Guías
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="font-semibold text-foreground mb-3">Legal</h3>
            <ul className="text-sm text-muted-foreground space-y-1">
              <li>
                <Link to="/about" className="hover:text-primary transition-colors duration-200">
                  Sobre nosotros
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-primary transition-colors duration-200">
                  Contacto
                </Link>
              </li>
              <li>
                <Link to="/privacidad" className="hover:text-primary transition-colors duration-200">
                  Política de Privacidad
                </Link>
              </li>
              <li>
                <Link to="/terminos" className="hover:text-primary transition-colors duration-200">
                  Términos de Uso
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="text-xs text-muted-foreground border-t border-border pt-4">
          <p>© {new Date().getFullYear()} CompresorJPEG. Herramienta gratuita para comprimir imágenes online. Todos los derechos reservados.</p>
          <p className="mt-2">Comprime JPG, PNG, WebP y más formatos sin perder calidad. 100% gratuito y seguro.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
